import IVendorServerConfig from '../../vendor_core/core/src/server/configs/IVendorServerConfig';
import { ConfigurationTypes } from '../../vendor_core/core/src/const/ConfigurationTypes';
import GameModel from '../../vendor_core/core/src/model/GameModel';
import App from '../../vendor_core/core/src/App';

class VendorServerConfig implements IVendorServerConfig {

    public type: ConfigurationTypes = ConfigurationTypes.VENDOR_SERVER;
    private _partnerId: number = parseInt(GameModel.partnerid);
    private _gameId: string = "mysticspells";
    private _clientconfigurl: string;

    get clientconfigurl(): string {
        if (!this._clientconfigurl) {
            this._clientconfigurl = App.config.useClient3Api
            ? "https://dev-casino-client3.api.relaxg.net/capi/1.0/casino/games/getclientconfig"
            : "https://dev-casino-client.api.relaxg.net/capi/1.0/casino/games/getclientconfig";
        }

        return this._clientconfigurl
    }
    get gameId(): string {
        return this._gameId
    }
    parseParams(data: any): void {
        if (GameModel.urlParams.gameid) {
            // We have gameid provided at url params.
            // We must use this for Relax request in order to get the dynamic rtp.
            this._gameId = GameModel.urlParams.gameid;
        }

        data?.gameid ? this._gameId = data.gameid : null;     
        
        if (data && data.partnerid) {
            GameModel.partnerid = data.partnerid;
        }

        // Ensure we have a fallback partnerid 1.
        GameModel.partnerid = GameModel.partnerid || "1";
        
        data?.clientconfigurl ? this._clientconfigurl = data.clientconfigurl : null;
        if (data?.configurl) {
            data?.configurl.includes("/ios") ? this._clientconfigurl = data.configurl : this._clientconfigurl = `${data.configurl}/ios`
        }
    }

}

export default new VendorServerConfig()